module.exports = __webpack_public_path__ + "static/10(6)-8d154e48e553cda5b8d3d7a8b52e717c.jpg";